import { isChatroomMessageNewDay } from '../Chatroom.utils'

export function getChatroomShouldShowDateDivider({
  hasMoreOlder,
  index,
  message,
  previousMessage,
  timeZone,
}) {
  if (index === 0) {
    return !hasMoreOlder
  }

  return isChatroomMessageNewDay({
    currentMessage: message,
    previousMessage,
    timeZone,
  })
}

export function getChatroomMessagesUnreadDividerIndex({
  messages,
  unreadAnchorMessageUuid,
}) {
  if (!unreadAnchorMessageUuid || !messages || messages.length === 0) {
    return -1
  }

  return messages.findIndex(message => message.uuid === unreadAnchorMessageUuid)
}

export function isChatroomMessageEditing({ editingMessageUuid, message }) {
  return Boolean(editingMessageUuid) && message?.uuid === editingMessageUuid
}
